import * as dompack from "dompack";
import { getUTF8Length, limitUTF8Length } from "@webhare-system/internal/utf8";
import "./counter.css";


export class Counter
{
  /** @param options
      @cell options.count
      @cell options.limit
      @cell options.separator
      @cell options.cssclass Extra css class to add to the root node
  */
  constructor(options)
  {
    this._options = options || {};

    this._buildNode();
    this._updateState();
  }

  _buildNode()
  {
    this.node = dompack.create("div", { className: "wh-counter", childNodes:
        [ this._countnode =     dompack.create("span", { className: "wh-counter__count" })
        , this._separatornode = dompack.create("span", { className: "wh-counter__separator" })
        , this._limitnode =     dompack.create("span", { className: "wh-counter__limit" })
        ] });
  }

  _updateState()
  {
    let classes =
      { "wh-counter--havelimit":    this._options.limit
      , "wh-counter--limitreached": this._options.limit && this._options.count >= this._options.limit
      , "wh-counter--overflow":     this._options.limit && this._options.count > this._options.limit
      };

    if (this._options.cssclass)
      classes[this._options.cssclass] = true;

    dompack.toggleClasses(this.node, classes);
    this._countnode.textContent = this._options.count || 0;
    this._separatornode.textContent = this.separator || "/";
    this._limitnode.textContent = this._options.limit || 0;
  }

  /** @param updates
      @cell(integer) updates.count
      @cell(integer) updates.limit
  */
  update(updates)
  {
    Object.assign(this._options, updates);
    this._updateState();
  }
}

export class InputTextLengthCounter
{
  // node
  // _options
  // _input
  // _counter
  // _limit

  constructor(node, options)
  {
    this._options = Object.assign(
        { showcounter:        true
        , forcelimit:         true          //concat text to given max length
        , input:              null          //input to count
        , separator:          "/"
        , cssclass:           ""            //additional css class
        , maxlengthmeasure:   "characters" // characters or bytes
        }, options || {});

    this.node = node;

    this._input = this._options.input || node.querySelector("input,textarea");
    if (!this._input)
      throw new Error("Could not locate input node to count");

    this._limit = Number(this._input.get("maxlength"));
    if (this._options.showcounter)
    {
      this._counter = new Counter(
          { count:        this._getTextlength()
          , limit:        this._limit
          , separator:    this._options.separator
          , cssclass:     this._options.cssclass
          });

      this.node.appendChild(this._counter.node);
    }

    //use keyup event because of behavour of IE
    this._input.addEvent("keydown", () => this.update());
    this._input.addEvent("input", () => this.update());
  }

  _getTextlength()
  {
    return (this._options.maxlengthmeasure === "bytes"
        ? getUTF8Length(this._input.get("value"))
        : this._input.get("value").length);
  }

  update()
  {
    this._limit = Number(this._input.get("maxlength"));

    let updates =
        { count:  this._getTextlength()
        , limit:  this._limit
        };

    if (this._limit > 0 && updates.count > this._limit && this._options.forcelimit)
    {
      var inptext = this._input.get("value");
      if (this._options.maxlengthmeasure === "bytes")
        inptext = limitUTF8Length(inptext, this._limit);
      else
        inptext = inptext.substring(0, this._limit);

      this._input.set("value", inptext);
      updates.count = this._getTextlength();
    }

    if (this._counter)
      this._counter.update(updates);
  }
}



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/components/basecontrols/counter.es